module.exports = __webpack_public_path__ + "static/media/lp4.157cb933.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lp4.webp
// module id = 681
// module chunks = 31